import SortingTempl from './sorting.pug';

require('../../assets/svg/filter-asc.svg');
require('../../assets/svg/filter-desc.svg');

export default {
  template: SortingTempl(),
  delimiters: ['${', '}}'],
  props: {
    title: {
      type: String,
      default: 'Сортировать:',
    },
    options: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {

  },
  methods: {
    checkValue(e) {
      const filterName = e.target.dataset.name.split('-');
      const newOption = this.options.filter(item => item.name.split('-')[0] === filterName[0] && item.value !== e.target.value);
      if (newOption.length > 0) {
        if (newOption[0].value.indexOf('asc') !== -1) {
          e.target.classList.remove('desc');
          e.target.classList.add('asc');
        } else {
          e.target.classList.add('desc');
          e.target.classList.remove('asc');
        }
        e.target.value = newOption[0].value;
      }
      this.$emit('set-value', e);
    },
  },
};



// WEBPACK FOOTER //
// ./new-blocks/sorting/sorting.js